import React from 'react'
import { Icon } from './Check.elements'

type Props = {
  className?: string
  variant?: 'slim' | 'fat'
}

export const CheckIcon = ({ className, variant = 'fat' }: Props) => (
  <Icon
    viewBox={variant === 'fat' ? '0 0 48 48' : '0 0 47 35'}
    aria-hidden
    focusable={false}
    role="img"
    className={className}
  >
    <path
      fill={variant === 'fat' ? 'currentColor' : 'none'}
      d={variant === 'fat'
        ? 'M19.55 41.9L0 22.23l7.28-7.34 12.27 12.35L40.63 6l7.28 7.34z'
        : 'M2.76 17l13.455 13.455 28.08-28.08'
      }
      stroke="currentColor"
      strokeWidth={variant === 'slim' ? 6 : 0}
    />
  </Icon>
)
